import { Builder, withChildren } from '@builder.io/react';

import Section from '../../elements/section/index';

const SectionWithBuilderChildren = withChildren(Section);

Builder.registerComponent(SectionWithBuilderChildren, {
  name: 'SectionFAQ',
  inputs: [
    {
      name: 'id',
      type: 'string'
    },
    {
      name: 'container',
      type: 'boolean'
    },
    {
      name: 'bg',
      type: 'string',
      defaultValue: 'bg-transparent',
      enum: [
        'bg-transparent',
        'bg-neutral-950',
        'bg-neutral-900',
        'bg-neutral-100',
        'bg-neutral-800'
      ]
    },
    {
      name: 'relative',
      type: 'boolean'
    },
    {
      name: 'paddingTop',
      type: 'boolean'
    },
    {
      name: 'paddingBottom',
      type: 'boolean'
    },
    {
      name: 'overflowHidden',
      type: 'boolean'
    }
  ],
  defaultChildren: [
    {
      component: {
        name: 'FAQ',
        options: {
          overtitle: 'Duis Mollis',
          title: 'FAQ',
          faqs: [
            {
              question: 'Fermentum Commodo Euismod Vestibulum?',
              answer:
                'Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio semnec elit. Nullam id dolor id nibh ultricies vehicula ut id elit. Aenean lacinia bibendum nulla sed consectetur. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.'
            },
            {
              question: 'Fermentum Commodo Euismod Vestibulum?',
              answer:
                'Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio semnec elit. Nullam id dolor id nibh ultricies vehicula ut id elit. Aenean lacinia bibendum nulla sed consectetur. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.'
            }
          ]
        }
      }
    }
  ]
});
